import HEART_BOMB_IMAGE_URL from './heart.png';
export { HEART_BOMB_IMAGE_URL };
export const HEART_BOMB_SPRITESHEET_DATA = {
    frames: {
        'heart0001.png': {
            frame: { x: 2, y: 2, w: 128, h: 140 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 20, w: 128, h: 140 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0002.png': {
            frame: { x: 2, y: 143, w: 123, h: 145 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 15, w: 123, h: 145 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0003.png': {
            frame: { x: 2, y: 289, w: 111, h: 150 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 8, y: 11, w: 111, h: 150 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0004.png': {
            frame: { x: 243, y: 131, w: 92, h: 159 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 17, y: 4, w: 92, h: 159 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0005.png': {
            frame: { x: 418, y: 2, w: 69, h: 163 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 28, y: 0, w: 69, h: 163 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0006.png': {
            frame: { x: 153, y: 294, w: 48, h: 163 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 38, y: 0, w: 48, h: 163 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0007.png': {
            frame: { x: 317, y: 326, w: 30, h: 162 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 46, y: 1, w: 30, h: 162 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0008.png': {
            frame: { x: 317, y: 357, w: 30, h: 162 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 46, y: 1, w: 30, h: 162 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0009.png': {
            frame: { x: 153, y: 343, w: 48, h: 163 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 37, y: 0, w: 48, h: 163 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0010.png': {
            frame: { x: 243, y: 224, w: 69, h: 163 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 26, y: 0, w: 69, h: 163 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0011.png': {
            frame: { x: 407, y: 166, w: 92, h: 159 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 16, y: 3, w: 92, h: 159 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0012.png': {
            frame: { x: 131, y: 126, w: 111, h: 151 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 8, y: 9, w: 111, h: 151 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0013.png': {
            frame: { x: 131, y: 2, w: 123, h: 145 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 2, y: 15, w: 123, h: 145 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        },
        'heart0014.png': {
            frame: { x: 277, y: 2, w: 128, h: 140 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 20, w: 128, h: 140 },
            sourceSize: { w: 128, h: 163 },
            anchor: { x: 0.490196, y: 0.546012 }
        }
    },
    animations: {
        animation: [
            'heart0001.png',
            'heart0002.png',
            'heart0003.png',
            'heart0004.png',
            'heart0005.png',
            'heart0006.png',
            'heart0007.png',
            'heart0008.png',
            'heart0009.png',
            'heart0010.png',
            'heart0011.png',
            'heart0012.png',
            'heart0013.png',
            'heart0014.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: HEART_BOMB_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 501, h: 402 },
        scale: '0.5',
        smartupdate: '$TexturePacker:SmartUpdate:58748184b18850979c01bdccf7cf8e40:9b20746cf9a3787f80d675f782d0bcb9:cb39580ce6d86b4835ef90f0a2df983e$'
    }
};
